import React from "react";

// reactstrap components
import {

  Container

} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";


function PoliticasDatosPersonales() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>
            <h3 className="title text-center" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
              Política de tratamiento de datos personales
            </h3>
            <center className="mt-5">
              <a
                href="#tratamiento-datos-personales"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/tratamiento-datos-personales.json",
                    "tratamiento-datos-personales.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Politica  de Tratamientos"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Política de tratamiento de datos personales</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default PoliticasDatosPersonales;
